import React, { useRef } from 'react';

const DegenCallsComponent = () => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const textRef = useRef<HTMLDivElement | null>(null);
	const imageRef = useRef<HTMLImageElement | null>(null);
	const bg1Ref = useRef<HTMLDivElement | null>(null);
	const bg2Ref = useRef<HTMLDivElement | null>(null);
	const bg3Ref = useRef<HTMLDivElement | null>(null);
	
	return (
		<div className="degenCallsComponent projectsPanel" ref={containerRef} id="testComp__content_data_item_id_4">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="degenCallsComponent__content">
				<div
					className="degenCallsComponent__content_data"
					ref={textRef}
				>
					<h2>High-risk and fast activities</h2>
					<span>Within this section, there is also a calendar of activities and feeds tailored specifically to the activities in this section.</span>
				</div>
				<div
					className="degenCallsComponent__content_image"
					ref={imageRef}
				>
					<div
						className="degenCallsComponent__content_image_background_1"
						ref={bg1Ref}
					></div>
					<div
						className="degenCallsComponent__content_image_background_2"
						ref={bg2Ref}
					></div>
					<div
						className="degenCallsComponent__content_image_background_3"
						ref={bg3Ref}
					></div>
					<img src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/degenCalls/MainImage.webp`} alt="Main"/>
				</div>
			</div>
		</div>
	);
};

export default DegenCallsComponent;